import React from 'react';
import PageHeader from '../components/PageHeader';
import '../css/deansw.css'; // Update the CSS file name

const MTECHSFResultpage = () => {
    return (

        <div class="container">

            <div class="row">

                <br />


                <h4 align='center'>Institute Spot Round (ISR-2025)  <br />
                    M. Tech (Regular) Admissions: A.Y. 2025-2026<br />
                    ONLINE AND PHYSCIAL REPROTING INSTRUCTIONS <br />
                </h4><br />
                <p>Online applications were invited through the NITWAS ERP portal from 10:00 AM on 13/08/2025 to 12:00 Noon on 14/08/2025 from eligible candidates for the M.Tech. programme (Self Finance). Based on the written test, interview, merit order and existing vacancies, the following candidates have been provisionally selected for admission to the M.Tech. (Self -Finance) programme across various departments for the academic year 2025–26 through ISR-2025. </p>

                <h5 class="mb-3 text-primary">Important Instructions:</h5>

                <p>Provisionally selected candidates must pay the seat acceptance fee of ₹1,02,500/-, which includes: Tuition fee for the first semester: ₹60,000/- & Other institutional fees for the first year: ₹42,500/-</p>

                <p>In addition, a hostel fee of ₹43,000/- must be paid.</p>

                <p>Payments must be made using the link provided in NITWAS ERP login of the candidate on 17th August 2025.</p>

                <p>Candidates are also required to attend physical reporting on 17th August 2025 as per the ISR-2025 schedule</p>


                <h5 class="mt-4 mb-3 text-danger">Note:</h5>

<p>Failure to pay the seat acceptance fee by the deadline (17th August 2025), and/or failure to attend the physical reporting on 17th August 2025, will result in automatic cancellation of the allotted seat. No further claims on the provisionally allotted seat will be entertained.</p>

<p>Candidates are advised to strictly follow the instructions mentioned therein. Please visit the institute and admission websites: 
<a href="https://www.nitw.ac.in" target="_blank">https://www.nitw.ac.in</a> (and) 
<a href="https://admissions.nitw.ac.in/" target="_blank">https://admissions.nitw.ac.in/</a> for regular updates.</p>
<h5 class="mt-4 mb-3 text-primary">Important Note:</h5>

<p>The candidates, whose final results awaited are advised to note that they should obtain:</p>

<p>(i) at least 60% aggregate marks or 6.5 CGPA on 10-point scale.</p>
<p>(ii) SC/ST/PwD candidates with 55% aggregate marks or 6.0 CGPA on 10-point scale.</p>
<p>(iii) Please visit the institute and admission websites: 
<a href="https://www.nitw.ac.in" target="_blank">https://www.nitw.ac.in</a> (and) 
<a href="https://admissions.nitw.ac.in/" target="_blank">https://admissions.nitw.ac.in/</a> for regular updates.</p>


<h5>Department of Civil Engineering</h5>
<table class="table table-bordered table-striped">
  <thead>
    <tr>
      <th>S.No.</th>
      <th>Application ID</th>
      <th>Specialization</th>
    </tr>
  </thead>
  <tbody>
    <tr><td>1</td><td>MT325CE00007</td><td>Engineering Structures</td></tr>
    <tr><td>2</td><td>MT325CE00022</td><td>Geo-Technical Engineering</td></tr>
    <tr><td>3</td><td>MT325CE00032</td><td>Geo-Technical Engineering</td></tr>
    <tr><td>4</td><td>MT325CE00036</td><td>Geo-Technical Engineering</td></tr>
    <tr><td>5</td><td>MT325CE00015</td><td>Geoinformatics</td></tr>
    <tr><td>6</td><td>MT325CE00008</td><td>Environmental Engineering</td></tr>
    <tr><td>7</td><td>MT325CE00012</td><td>Environmental Engineering</td></tr>
    <tr><td>8</td><td>MT325CE00027</td><td>Environmental Engineering</td></tr>
  </tbody>
</table>


<h5>Department of Electrical Engineering</h5>
<table class="table table-bordered table-striped">
  <thead>
    <tr>
      <th>S.No.</th>
      <th>Application ID</th>
      <th>Specialization</th>
    </tr>
  </thead>
  <tbody>
    <tr><td>1</td><td>MT325EE00003</td><td>Smart Electric Grid</td></tr>
    <tr><td>2</td><td>MT325EE00009</td><td>Smart Electric Grid</td></tr>
    <tr><td>3</td><td>MT325EE00011</td><td>Smart Electric Grid</td></tr>
    <tr><td>4</td><td>MT325EE00014</td><td>Smart Electric Grid</td></tr>
    <tr><td>5</td><td>MT325EE00015</td><td>Smart Electric Grid</td></tr>
    <tr><td>6</td><td>MT325EE00020</td><td>Smart Electric Grid</td></tr>
    <tr><td>7</td><td>MT325EE00006</td><td>Control and Automation</td></tr>
    <tr><td>8</td><td>MT325EE00008</td><td>Control and Automation</td></tr>
    <tr><td>9</td><td>MT325EE00024</td><td>Control and Automation</td></tr>
  </tbody>
</table>


<h5>Department of Mechanical Engineering</h5>
<table class="table table-bordered table-striped">
  <thead>
    <tr>
      <th>S.No.</th>
      <th>Application ID</th>
      <th>Specialization</th>
    </tr>
  </thead>
  <tbody>
    <tr><td>1</td><td>MT325ME00001</td><td>Manufacturing Engineering</td></tr>
    <tr><td>2</td><td>MT325ME00002</td><td>Manufacturing Engineering</td></tr>
    <tr><td>3</td><td>MT325ME00003</td><td>Manufacturing Engineering</td></tr>
    <tr><td>4</td><td>MT325ME00012</td><td>Manufacturing Engineering</td></tr>
    <tr><td>5</td><td>MT325ME00018</td><td>Manufacturing Engineering</td></tr>
    <tr><td>6</td><td>MT325ME00028</td><td>Manufacturing Engineering</td></tr>
  </tbody>
</table>


<h5>Department of Electronics & Communication Engineering</h5>
<table class="table table-bordered table-striped">
  <thead>
    <tr>
      <th>S.No.</th>
      <th>Application ID</th>
      <th>Specialization</th>
    </tr>
  </thead>
  <tbody>
    <tr><td>1</td><td>MT325EC00004</td><td>Embedded and Machine Learning Systems</td></tr>
    <tr><td>2</td><td>MT325EC00006</td><td>Embedded and Machine Learning Systems</td></tr>
    <tr><td>3</td><td>MT325EC00022</td><td>Embedded and Machine Learning Systems</td></tr>
    <tr><td>4</td><td>MT325EC00002</td><td>Advanced Communication Systems</td></tr>
    <tr><td>5</td><td>MT325EC00008</td><td>Advanced Communication Systems</td></tr>
    <tr><td>6</td><td>MT325EC00009</td><td>Advanced Communication Systems</td></tr>
    <tr><td>7</td><td>MT325EC00012</td><td>Advanced Communication Systems</td></tr>
    <tr><td>8</td><td>MT325EC00014</td><td>Advanced Communication Systems</td></tr>
    <tr><td>9</td><td>MT325EC00015</td><td>Advanced Communication Systems</td></tr>
    <tr><td>10</td><td>MT325EC00025</td><td>Advanced Communication Systems</td></tr>
    <tr><td>11</td><td>MT325EC00028</td><td>Advanced Communication Systems</td></tr>
  </tbody>
</table>


<h5>Department of Chemical Engineering</h5>
<table class="table table-bordered table-striped">
  <thead>
    <tr>
      <th>S.No.</th>
      <th>Application ID</th>
      <th>Specialization</th>
    </tr>
  </thead>
  <tbody>
    <tr><td>1</td><td>MT325CH00002</td><td>Chemical Engineering</td></tr>
    <tr><td>2</td><td>MT325CH00001</td><td>Sustainable Energy Generation and Storage Technologies</td></tr>
    <tr><td>3</td><td>MT325CH00003</td><td>Sustainable Energy Generation and Storage Technologies</td></tr>
    <tr><td>4</td><td>MT325CH00004</td><td>Sustainable Energy Generation and Storage Technologies</td></tr>
  </tbody>
</table>


<h5>Department of Computer Science & Engineering</h5>
<table class="table table-bordered table-striped">
  <thead>
    <tr>
      <th>S.No.</th>
      <th>Application ID</th>
      <th>Specialization</th>
    </tr>
  </thead>
  <tbody>
    <tr><td>1</td><td>MT325CS00057</td><td>Computer Science and Information Security</td></tr>
    <tr><td>2</td><td>MT325CS00058</td><td>Computer Science and Information Security</td></tr>
    <tr><td>3</td><td>MT325CS00060</td><td>Computer Science and Information Security</td></tr>
    <tr><td>4</td><td>MT325CS00071</td><td>Computer Science and Information Security</td></tr>
    <tr><td>5</td><td>MT325CS00081</td><td>Computer Science and Information Security</td></tr>
    <tr><td>6</td><td>MT325CS00082</td><td>Computer Science and Information Security</td></tr>
    <tr><td>7</td><td>MT325CS00096</td><td>Computer Science and Information Security</td></tr>
    <tr><td>8</td><td>MT325CS00111</td><td>Computer Science and Information Security</td></tr>
  </tbody>
</table>


<h5>Department of Bio-Technology</h5>
<table class="table table-bordered table-striped">
  <thead>
    <tr>
      <th>S.No.</th>
      <th>Application ID</th>
      <th>Specialization</th>
    </tr>
  </thead>
  <tbody>
    <tr><td>1</td><td>MT325BT00004</td><td>Bio-Technology</td></tr>
  </tbody>
</table>
   <ol>
                    <li><a href='https://nitw.ac.in/api/static/files/mtech_sf_regular_2025-8-16-22-49-53.pdf' target='_blank' class="btn btn-primary mt-2">1. Instructions to be followed by the provisionally selected candidates for Online and Physical
                        reporting</a></li>

                </ol>






{/* old code */}

                <br />
                <h3 align='center'>Institute Spot Round (ISR-2025)<br />
                    M. Tech (Regular) Admissions: A.Y. 2025-2026</h3>
                <p>Online applications were invited through the NITWAS ERP portal from <b>10:00 AM on 13/08/2025
                    to 12:00 Noon on14/08/2025</b> from eligible candidates for the M.Tech. programme (with a valid
                    GATE score). Based on the GATE percentile and in accordance with the Government of India
                    reservation norms, the following candidates have been <b> provisionally selected </b>for admission to the
                    M.Tech. (Regular) programme across various departments through ISR-2025 for the academic year
                    2025–2026.</p>
                <h5 className="mb-3">Important Instructions:</h5>
                <ul className="list-group" style={{ listStyleType: "disc", paddingLeft: "1.5rem" }}>
                    <li>
                        • Provisionally selected candidates must pay the <strong>seat acceptance fee of ₹77,500/-,</strong> which includes: Tuition fee for the first semester: ₹35,000/- & Other institutional fees for the first year: ₹42,500/-.
                    </li>
                    <li >
                        • In addition, a ,<strong>hostel fee of ₹43,000/-</strong> must be paid.
                    </li>
                    <li >
                        • Payments must be made using the respective links provided for each phase, strictly on <strong>16th August 2025.</strong>
                    </li>
                    <li >
                        • Candidates are also required to attend <strong>physical reporting on 17th August 2025</strong> as per the ISR-2025 schedule.
                    </li>
                    <li >
                        <strong>Note:</strong> Failure to pay the seat acceptance fee by the deadline (16th August 2025), and/or failure to attend the physical reporting on 17th August 2025, will result in <strong>automatic cancellation</strong> of the allotted seat. No further claims on the provisionally allotted seat will be entertained.
                    </li>

                </ul>
                <p >
                    Candidates are advised to strictly follow the instructions mentioned therein. Please visit the institute and admission websites:{" "}
                    <a href="https://www.nitw.ac.in" target="_blank" rel="noreferrer">https://www.nitw.ac.in</a> (and){" "}
                    <a href="https://admissions.nitw.ac.in/" target="_blank" rel="noreferrer">https://admissions.nitw.ac.in/</a> for regular updates.
                </p>
                <h5 className="mb-2">Important Note:</h5>
                <p>The candidates, whose final results are awaited are advised to note that they should obtain:</p>
                <p>(i) at least 60% aggregate marks or 6.5 CGPA on 10-point scale.</p>
                <p>(ii) SC/ST/PwD candidates with 55% aggregate marks or 6.0 CGPA on 10-point scale.</p>
                <p>(iii) Valid GATE Score and eligibility conditions as per{" "}
                    <a href="https://ccmt.admissions.nic.in/" target="_blank" rel="noreferrer">
                        https://ccmt.admissions.nic.in/
                    </a> guidelines.
                </p>
                <table className="table table-bordered">
                    <thead>
                        <tr>
                            <th>S.No.</th>
                            <th>Application ID</th>
                            <th>Specialization Name</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>1</td>
                            <td>MT325CE00034</td>
                            <td>Geotechnical Engineering</td>
                        </tr>

                        {/* Environmental Engineering */}
                        <tr>
                            <td>2</td>
                            <td>MT325CE00014</td>
                            <td>Environmental Engineering</td>
                        </tr>
                        <tr>
                            <td>3</td>
                            <td>MT325CE00031</td>
                            <td>Environmental Engineering</td>
                        </tr>

                        {/* Water Resource Engineering */}
                        <tr>
                            <td>4</td>
                            <td>MT325CE00006</td>
                            <td>Water Resource Engineering</td>
                        </tr>
                        <tr>
                            <td>5</td>
                            <td>MT325EE00013</td>
                            <td>Smart Electric Grid</td>
                        </tr>
                        <tr>
                            <td>6</td>
                            <td>MT325ME00011</td>
                            <td>Automobile Engineering</td>
                        </tr>
                        <tr>
                            <td>7</td>
                            <td>MT325ME00005</td>
                            <td>Automobile Engineering</td>
                        </tr>
                        <tr>
                            <td>8</td>
                            <td>MT325ME00020</td>
                            <td>Thermal Engineering</td>
                        </tr>
                        <tr>
                            <td>9</td>
                            <td>MT325EC00021</td>
                            <td>Advanced Communication System</td>
                        </tr>
                        <tr>
                            <td>10</td>
                            <td>MT325CS00140</td>
                            <td>Computer Science & Information Securityg</td>
                        </tr>
                    </tbody>
                </table>

                <br /><br />
                <ol>
                    <li><a href='https://nitw.ac.in/api/static/files/mtech_str_gate_2025-8-15-17-18-13.pdf' target='_blank' class="btn btn-primary mt-2">1. Instructions to be followed by the provisionally selected candidates for Online and Physical
                        reporting</a></li>

                </ol>


                <br />


                <h4 align='center'>M. Tech (Self Finance) Admissions: Academic Year 2025-2026</h4><br />
                <h4 align='center' style={{ color: "red" }}>Provisionally Selected Candidates of M.Tech. (Self Finance) Admissions for AY 2025-26 (Phase-III).</h4>
                <p>The selection process for the shortlisted candidates were conducted during May 19 to 23, 2025.  Based on the performances in written exam based on GATE syllabus and personal interview, the following candidates are provisionally selected for the first phase of admissions to M. Tech (Self Finance) programme for the academic year 2025-2026.  </p>
                <p>Each provisionally selected candidate is required to pay the seat acceptance fee of Rs. 1,02,500/- (which comprises of tuition fee of Rs. 50,000/- for first semester, contingency of Rs. 10,000 for first semester, and other fee of Rs. 42,500/- for first year) along with the hostel fee of Rs. 43,000/- (full details are available at https://admissions.nitw.ac.in/impinstructions/) by using the links given against each phase during scheduled dates 09-10, June 2025.  </p>
                <p>Detailed instructions and the schedule for the remaining phases (if any vacant seats are available) are provided in the attached file. Candidates are advised to strictly follow the instructions mentioned therein.</p>
                <p>Please visit the institute and admission websites: <a href='https://www.nitw.ac.in' target='_balnk'>https://www.nitw.ac.in</a> (and) <a href='https://admissions.nitw.ac.in/' target='_balnk'>https://admissions.nitw.ac.in/ </a>for regular updates.</p>
                <h4><u>LIST OF PROVISIONALLY SELECTED CANDIDATES</u></h4>
                {/* <h5 style={{ color: "#2b4675" }}><b>Department of Civil Engineering:</b></h5> */}
                <table className="table table-bordered">
                    <tbody>
                        <tr><th>S.No.</th><th>Application ID</th><th>Specilization Name</th></tr>
                        <tr>
                            <td>1</td>
                            <td>MT125EC00079</td>
                            <td>Embedded &  Machine Learning Systems</td>
                        </tr>
                        <tr>
                            <td>2</td>
                            <td>MT125EC00542</td>
                            <td>Embedded & Machine Learning Systems</td>
                        </tr>

                    </tbody>
                </table>
                <table className="table table-bordered">
                    <tbody>
                        <tr><th>S.No.</th><th>Application ID</th><th>Specilization Name</th></tr>
                        <tr>
                            <td>1</td>
                            <td>MT125EC00127</td>
                            <td>Advanced Communication System</td>
                        </tr>
                        <tr>
                            <td>2</td>
                            <td>MT125EC00525</td>
                            <td>Advanced Communication System</td>
                        </tr>
                        <tr>
                            <td>3</td>
                            <td>MT125EC00128</td>
                            <td>Advanced Communication System</td>
                        </tr>
                        <tr>
                            <td>4</td>
                            <td>MT125EC00490</td>
                            <td>Advanced Communication System</td>
                        </tr>
                        <tr>
                            <td>5</td>
                            <td>MT125EC00679</td>
                            <td>Advanced Communication System</td>
                        </tr>

                    </tbody>
                </table>
                <table className="table table-bordered">
                    <tbody>
                        <tr><th>S.No.</th><th>Application ID</th><th>Specilization Name</th></tr>
                        <tr>
                            <td>1</td>
                            <td>MT125BT00132</td>
                            <td>Biotechnology</td>
                        </tr>


                    </tbody>
                </table>

                <br /><br />
                <ol>
                    <li><a href='https://nitw.ac.in/api/static/files/mtechsf25_pahse3_2025-6-7-20-26-44.pdf' target='_blank' class="btn btn-primary mt-2">1. Instructions and Physical Reporting schedule for the provisionally selected candidates for M. Tech (Self Finance) Admissions - 2025.</a></li>

                </ol>


                <br />




                <h4 align='center' style={{ color: "red" }}>Provisionally Selected Candidates of M.Tech. (Self Finance) Admissions for AY 2025-26 (Phase-II).</h4>
                <p>The selection process for the shortlisted candidates were conducted during May 19 to 23, 2025.  Based on the performances in written exam based on GATE syllabus and personal interview, the following candidates are provisionally selected for the first phase of admissions to M. Tech (Self Finance) programme for the academic year 2025-2026. </p>
                <p>Each provisionally selected candidate is required to pay the seat acceptance fee of Rs. 1,02,500/- (which comprises of tuition fee of Rs. 50,000/- for first semester, contingency of Rs. 10,000 for first semester, and other fee of Rs. 42,500/- for first year) along with the hostel fee of Rs. 43,000/- (full details are available at https://admissions.nitw.ac.in/impinstructions/) by using the links given against each phase during scheduled dates 05-06, June 2025. </p>
                <p>Detailed instructions and the schedule for the remaining phases (if any vacant seats are available) are provided in the attached file. Candidates are advised to strictly follow the instructions mentioned therein.</p>
                <p>Please visit the institute and admission websites: <a href='https://www.nitw.ac.in' target='_balnk'>https://www.nitw.ac.in</a> (and) <a href='https://admissions.nitw.ac.in/' target='_balnk'>https://admissions.nitw.ac.in/ </a>for regular updates.</p>
                <h4><u>LIST OF PROVISIONALLY SELECTED CANDIDATES</u></h4>
                {/* <h5 style={{ color: "#2b4675" }}><b>Department of Civil Engineering:</b></h5> */}
                <table className="table table-bordered">
                    <tbody>
                        <tr><th>S.No.</th><th>Application ID</th><th>Specilization Name</th></tr>
                        <tr>
                            <td>1</td>
                            <td>MT125CE00234</td>
                            <td>Geotechnical Engineering</td>
                        </tr>
                        <tr>
                            <td>2</td>
                            <td>MT125CE00178</td>
                            <td>Geotechnical Engineering</td>
                        </tr>
                        <tr>
                            <td>3</td>
                            <td>MT125CE00197</td>
                            <td>Geotechnical Engineering</td>
                        </tr>
                    </tbody>
                </table>
                <table className="table table-bordered">
                    <tbody>
                        <tr><th>S.No.</th><th>Application ID</th><th>Specilization Name</th></tr>
                        <td>1</td>
                        <td>MT125CE00148</td>
                        <td>Transportation Engineering</td>
                    </tbody>
                </table>
                <table className="table table-bordered">
                    <tbody>
                        <tr><th>S.No.</th><th>Application ID</th><th>Specilization Name</th></tr>
                        <td>1</td>
                        <td>MT125ME00082</td>
                        <td>Automobile Engineering</td>
                    </tbody>
                </table>
                <table className="table table-bordered">
                    <tbody>
                        <tr><th>S.No.</th><th>Application ID</th><th>Specilization Name</th></tr>
                        <tr>
                            <td>1</td>
                            <td>MT125ME00015</td>
                            <td>Machine Design</td>
                        </tr>
                        <tr>
                            <td>2</td>
                            <td>MT125ME00070</td>
                            <td>Machine Design</td>
                        </tr>
                        <tr>
                            <td>3</td>
                            <td>MT125ME00160</td>
                            <td>Machine Design</td>
                        </tr>
                    </tbody>
                </table>
                <table className="table table-bordered">
                    <tbody>
                        <tr><th>S.No.</th><th>Application ID</th><th>Specilization Name</th></tr>
                        <tr>
                            <td>1</td>
                            <td>MT125EC00127</td>
                            <td>Embedded & Machine Learning Systems</td>
                        </tr>
                        <tr>
                            <td>2</td>
                            <td>MT125EC00170</td>
                            <td>Embedded & Machine Learning Systems</td>
                        </tr>
                        <tr>
                            <td>3</td>
                            <td>MT125EC00139</td>
                            <td>Embedded & Machine Learning Systems</td>
                        </tr>
                        <tr>
                            <td>4</td>
                            <td>MT125EC00610</td>
                            <td>Embedded & Machine Learning Systems</td>
                        </tr>
                        <tr>
                            <td>5</td>
                            <td>MT125EC00099</td>
                            <td>Embedded & Machine Learning Systems</td>
                        </tr>
                        <tr>
                            <td>6</td>
                            <td>MT125EC00115</td>
                            <td>Embedded & Machine Learning Systems</td>
                        </tr>
                        <tr>
                            <td>7</td>
                            <td>MT125EC00132</td>
                            <td>Embedded & Machine Learning Systems</td>
                        </tr>
                    </tbody>
                </table>
                <table className="table table-bordered">
                    <tbody>
                        <tr><th>S.No.</th><th>Application ID</th><th>Specilization Name</th></tr>
                        <tr>
                            <th>S.No.</th>
                            <th>Application ID</th>
                            <th>Specialization Name</th>
                        </tr>
                        <tr>
                            <td>1</td>
                            <td>MT125EC00184</td>
                            <td>Advanced Communication System</td>
                        </tr>
                        <tr>
                            <td>2</td>
                            <td>MT125EC00600</td>
                            <td>Advanced Communication System</td>
                        </tr>
                        <tr>
                            <td>3</td>
                            <td>MT125EC00079</td>
                            <td>Advanced Communication System</td>
                        </tr>
                        <tr>
                            <td>4</td>
                            <td>MT125EC00333</td>
                            <td>Advanced Communication System</td>
                        </tr>
                        <tr>
                            <td>5</td>
                            <td>MT125EC00683</td>
                            <td>Advanced Communication System</td>
                        </tr>
                        <tr>
                            <td>6</td>
                            <td>MT125EC00426</td>
                            <td>Advanced Communication System</td>
                        </tr>

                    </tbody>
                </table>
                <table className="table table-bordered">
                    <tbody>
                        <tr><th>S.No.</th><th>Application ID</th><th>Specilization Name</th></tr>
                        <tr>
                            <td>1</td>
                            <td>MT125CS00826</td>
                            <td>Computer Science and Information Security</td>
                        </tr>
                    </tbody>
                </table>
                <table className="table table-bordered">
                    <tbody>
                        <tr><th>S.No.</th><th>Application ID</th><th>Specilization Name</th></tr>
                        <tr>
                            <td>1</td>
                            <td>MT125BT00117</td>
                            <td>Biotechnology</td>
                        </tr>
                        <tr>
                            <td>2</td>
                            <td>MT125BT000113</td>
                            <td>Biotechnology</td>
                        </tr>
                    </tbody>
                </table>
                <br /><br />
                <ol>
                    <li><a href='https://nitw.ac.in/api/static/files/mtechsfay25_26_phase2_2025-6-2-20-24-9.pdf' target='_blank' class="btn btn-primary mt-2">1. Instructions and Physical Reporting schedule for the provisionally selected candidates for M. Tech (Self Finance) Admissions - 2025.</a></li>

                </ol>


                <br />

                <h4 align='center' style={{ color: "red" }}>Provisionally selected candidates for M.Tech. (Self-Financed) admissions for the AY 2025–26 (Phase-I).</h4>

                <p>The selection process for the shortlisted candidates were conducted during May 19 to 23, 2025.
                    Based on the performances in written exam based on GATE syllabus and personal interview,
                    the following candidates are <b>provisionally selected</b> for the first phase of admissions to M. Tech (Self Finance) programme for the academic year 2025-2026.</p>
                <p>Detailed instructions and the schedule for the remaining phases (if any vacant seats are available) are provided in the attached file. Candidates are advised to strictly follow the instructions mentioned therein.</p>
                <p>Please visit the institute and admission websites: <a href='https://www.nitw.ac.in' target='_balnk'>https://www.nitw.ac.in</a> (and) <a href='https://admissions.nitw.ac.in/' target='_balnk'>https://admissions.nitw.ac.in/ </a>for regular updates.
                </p>


                <h4><u>LIST OF PROVISIONALLY SELECTED CANDIDATES</u></h4>



                <h5 style={{ color: "#2b4675" }}><b>Department of Civil Engineering:</b></h5>
                <table className="table table-bordered">
                    <tbody>
                        <tr><th>S.No.</th><th>Application ID</th><th>Specilization Name</th></tr>
                        <tr><td>1</td><td>MT125CE00051</td><td>Construction Technology and Management</td></tr>
                        <tr><td>2</td><td>MT125CE00082</td><td>Construction Technology and Management</td></tr>
                        <tr><td>3</td><td>MT125CE00121</td><td>Construction Technology and Management</td></tr>
                        <tr><td>4</td><td>MT125CE00174</td><td>Construction Technology and Management</td></tr>
                        <tr><td>5</td><td>MT125CE00192</td><td>Construction Technology and Management</td></tr>
                        <tr><td>6</td><td>MT125CE00063</td><td>Construction Technology and Management</td></tr>
                        <tr><td>7</td><td>MT125CE00110</td><td>Construction Technology and Management</td></tr>
                        <tr><td>8</td><td>MT125CE00123</td><td>Construction Technology and Management</td></tr>
                        <tr><td>9</td><td>MT125CE00185</td><td>Construction Technology and Management</td></tr>
                        <tr><td>10</td><td>MT125CE00193</td><td>Construction Technology and Management</td></tr>

                    </tbody>
                </table>
                <table className="table table-bordered">
                    <tbody>
                        <tr><th>S.No.</th><th>Application ID</th><th>Specilization Name</th></tr>
                        <tr><td>1</td><td>MT125CE00050</td><td>Engineering Structures</td></tr>
                        <tr><td>2</td><td>MT125CE00098</td><td>Engineering Structures</td></tr>
                        <tr><td>3</td><td>MT125CE00101</td><td>Engineering Structures</td></tr>
                        <tr><td>4</td><td>MT125CE00165</td><td>Engineering Structures</td></tr>
                        <tr><td>5</td><td>MT125CE00212</td><td>Engineering Structures</td></tr>
                        <tr><td>6</td><td>MT125CE00056</td><td>Engineering Structures</td></tr>
                        <tr><td>7</td><td>MT125CE00100</td><td>Engineering Structures</td></tr>
                        <tr><td>8</td><td>MT125CE00157</td><td>Engineering Structures</td></tr>
                        <tr><td>9</td><td>MT125CE00176</td><td>Engineering Structures</td></tr>
                        <tr><td>10</td><td>MT125CE00227</td><td>Engineering Structures</td></tr>
                    </tbody>
                </table>


                <table className="table table-bordered">
                    <tbody>
                        <tr><th>S.No.</th><th>Application ID</th><th>Specilization Name</th></tr>
                        <tr><td>1</td><td>MT125CE00004</td><td>Environmental Engineering</td></tr>
                        <tr><td>2</td><td>MT125CE00115</td><td>Environmental Engineering</td></tr>
                        <tr><td>3</td><td>MT125CE00148</td><td>Environmental Engineering</td></tr>
                        <tr><td>4</td><td>MT125CE00196</td><td>Environmental Engineering</td></tr>
                        <tr><td>5</td><td>MT125CE00210</td><td>Environmental Engineering</td></tr>
                        <tr><td>6</td><td>MT125CE00058</td><td>Environmental Engineering</td></tr>
                        <tr><td>7</td><td>MT125CE00139</td><td>Environmental Engineering</td></tr>
                        <tr><td>8</td><td>MT125CE00154</td><td>Environmental Engineering</td></tr>
                        <tr><td>9</td><td>MT125CE00206</td><td>Environmental Engineering</td></tr>

                    </tbody>
                </table>
                <table className="table table-bordered">
                    <tbody>
                        <tr><th>S.No.</th><th>Application ID</th><th>Specilization Name</th></tr>
                        <tr><td>1</td><td>MT125CE00033</td><td>Geotechnical Engineering</td></tr>
                        <tr><td>2</td><td>MT125CE00039</td><td>Geotechnical Engineering</td></tr>
                        <tr><td>3</td><td>MT125CE00077</td><td>Geotechnical Engineering</td></tr>
                        <tr><td>4</td><td>MT125CE00090</td><td>Geotechnical Engineering</td></tr>
                        <tr><td>5</td><td>MT125CE00111</td><td>Geotechnical Engineering</td></tr>
                        <tr><td>6</td><td>MT125CE00152</td><td>Geotechnical Engineering</td></tr>
                        <tr><td>7</td><td>MT125CE00156</td><td>Geotechnical Engineering</td></tr>
                        <tr><td>8</td><td>MT125CE00191</td><td>Geotechnical Engineering</td></tr>
                        <tr><td>9</td><td>MT125CE00194</td><td>Geotechnical Engineering</td></tr>
                        <tr><td>10</td><td>MT125CE00220</td><td>Geotechnical Engineering</td></tr>
                    </tbody>
                </table>
                <table className="table table-bordered">
                    <tbody>
                        <tr><th>S.No.</th><th>Application ID</th><th>Specilization Name</th></tr>
                        <tr><td>1</td><td>MT125CE00017</td><td>Transportation Engineering</td></tr>
                        <tr><td>2</td><td>MT125CE00114</td><td>Transportation Engineering</td></tr>
                        <tr><td>3</td><td>MT125CE00119</td><td>Transportation Engineering</td></tr>
                        <tr><td>4</td><td>MT125CE00159</td><td>Transportation Engineering</td></tr>
                        <tr><td>5</td><td>MT125CE00224</td><td>Transportation Engineering</td></tr>
                        <tr><td>6</td><td>MT125CE00032</td><td>Transportation Engineering</td></tr>
                        <tr><td>7</td><td>MT125CE00117</td><td>Transportation Engineering</td></tr>
                        <tr><td>8</td><td>MT125CE00140</td><td>Transportation Engineering</td></tr>
                        <tr><td>9</td><td>MT125CE00163</td><td>Transportation Engineering</td></tr>
                        <tr><td>10</td><td>MT125CE00233</td><td>Transportation Engineering</td></tr>
                    </tbody>
                </table>
                <table className="table table-bordered">
                    <tbody>
                        <tr><th>S.No.</th><th>Application ID</th><th>Specilization Name</th></tr>
                        <tr><td>1</td><td>MT125CE00088</td><td>Water Resource Engineering</td></tr>
                        <tr><td>2</td><td>MT125CE00141</td><td>Water Resource Engineering</td></tr>
                        <tr><td>3</td><td>MT125CE00158</td><td>Water Resource Engineering</td></tr>
                        <tr><td>4</td><td>MT125CE00173</td><td>Water Resource Engineering</td></tr>
                        <tr><td>5</td><td>MT125CE00178</td><td>Water Resource Engineering</td></tr>
                        <tr><td>6</td><td>MT125CE00197</td><td>Water Resource Engineering</td></tr>
                    </tbody>
                </table>
                <table className="table table-bordered">
                    <tbody>
                        <tr><th>S.No.</th><th>Application ID</th><th>Specilization Name</th></tr>
                        <tr><td>1</td><td>MT125CE00019</td><td>Geoinformatics</td></tr>
                        <tr><td>2</td><td>MT125CE00097</td><td>Geoinformatics</td></tr>
                        <tr><td>3</td><td>MT125CE00181</td><td>Geoinformatics</td></tr>
                        <tr><td>4</td><td>MT125CE00235</td><td>Geoinformatics</td></tr>
                        <tr><td>5</td><td>MT125CE00029</td><td>Geoinformatics</td></tr>
                        <tr><td>6</td><td>MT125CE00160</td><td>Geoinformatics</td></tr>
                        <tr><td>7</td><td>MT125CE00234</td><td>Geoinformatics</td></tr>
                    </tbody>
                </table>
                {/* <table className="table table-bordered">
                    <tbody>
                        <tr><th>S.No.</th><th>Application ID</th><th>Specilization Name</th></tr>
                    </tbody>
                </table> */}


                <h5 style={{ color: "#2b4675" }}><b>Department of Electrical Engineering:</b></h5>
                <table className="table table-bordered">
                    <tbody>

                    </tbody>
                </table>
                <table className="table table-bordered">
                    <tbody>
                        <tr><th>S.No.</th><th>Application ID</th><th>Specilization Name</th></tr>
                        <tr><td>1</td><td>MT125EE00011</td><td>Power Electronics and Drives</td></tr>
                        <tr><td>2</td><td>MT125EE00015</td><td>Power Electronics and Drives</td></tr>
                        <tr><td>3</td><td>MT125EE00072</td><td>Power Electronics and Drives</td></tr>
                        <tr><td>4</td><td>MT125EE00097</td><td>Power Electronics and Drives</td></tr>
                        <tr><td>5</td><td>MT125EE00150</td><td>Power Electronics and Drives</td></tr>
                        <tr><td>6</td><td>MT125EE00012</td><td>Power Electronics and Drives</td></tr>
                        <tr><td>7</td><td>MT125EE00060</td><td>Power Electronics and Drives</td></tr>
                        <tr><td>8</td><td>MT125EE00091</td><td>Power Electronics and Drives</td></tr>
                        <tr><td>9</td><td>MT125EE00118</td><td>Power Electronics and Drives</td></tr>
                        <tr><td>10</td><td>MT125EE00169</td><td>Power Electronics and Drives</td></tr>
                    </tbody>
                </table>
                <table className="table table-bordered">
                    <tbody>
                        <tr><th>S.No.</th><th>Application ID</th><th>Specilization Name</th></tr>
                        <tr><td>1</td><td>MT125EE00007</td><td>Power Systems Engineering</td></tr>
                        <tr><td>2</td><td>MT125EE00049</td><td>Power Systems Engineering</td></tr>
                        <tr><td>3</td><td>MT125EE00056</td><td>Power Systems Engineering</td></tr>
                        <tr><td>4</td><td>MT125EE00079</td><td>Power Systems Engineering</td></tr>
                        <tr><td>5</td><td>MT125EE00093</td><td>Power Systems Engineering</td></tr>
                        <tr><td>6</td><td>MT125EE00013</td><td>Power Systems Engineering</td></tr>
                        <tr><td>7</td><td>MT125EE00053</td><td>Power Systems Engineering</td></tr>
                        <tr><td>8</td><td>MT125EE00076</td><td>Power Systems Engineering</td></tr>
                        <tr><td>9</td><td>MT125EE00082</td><td>Power Systems Engineering</td></tr>
                        <tr><td>10</td><td>MT125EE00180</td><td>Power Systems Engineering</td></tr>
                    </tbody>
                </table>
                <table className="table table-bordered">
                    <tbody>
                        <tr><th>S.No.</th><th>Application ID</th><th>Specilization Name</th></tr>
                        <tr><td>1</td><td>MT125EE00019</td><td>Smart Electric Grid</td></tr>
                        <tr><td>2</td><td>MT125EE00077</td><td>Smart Electric Grid</td></tr>
                        <tr><td>3</td><td>MT125EE00087</td><td>Smart Electric Grid</td></tr>
                        <tr><td>4</td><td>MT125EE00119</td><td>Smart Electric Grid</td></tr>
                    </tbody>
                </table>
                <table className="table table-bordered">
                    <tbody>
                        <tr><th>S.No.</th><th>Application ID</th><th>Specilization Name</th></tr>
                        <tr><td>1</td><td>MT125EE00003</td><td>Control & Automation</td></tr>
                        <tr><td>2</td><td>MT125EE00039</td><td>Control & Automation</td></tr>
                        <tr><td>3</td><td>MT125EE00105</td><td>Control & Automation</td></tr>
                        <tr><td>4</td><td>MT125EE00140</td><td>Control & Automation</td></tr>
                        <tr><td>5</td><td>MT125EE00149</td><td>Control & Automation</td></tr>
                        <tr><td>6</td><td>MT125EE00035</td><td>Control & Automation</td></tr>
                        <tr><td>7</td><td>MT125EE00067</td><td>Control & Automation</td></tr>
                        <tr><td>8</td><td>MT125EE00135</td><td>Control & Automation</td></tr>
                        <tr><td>9</td><td>MT125EE00148</td><td>Control & Automation</td></tr>
                        <tr><td>10</td><td>MT125EE00163</td><td>Control & Automation</td></tr>
                    </tbody>
                </table>

                <h5 style={{ color: "#2b4675" }}><b>Department of Mechanical Engineering:</b></h5>
                <table className="table table-bordered">
                    <tbody>
                        <tr><th>S.No.</th><th>Application ID</th><th>Specilization Name</th></tr>
                        <tr><td>1</td><td>MT125ME00012</td><td>Automobile Engineering</td></tr>
                        <tr><td>2</td><td>MT125ME00046</td><td>Automobile Engineering</td></tr>
                        <tr><td>3</td><td>MT125ME00061</td><td>Automobile Engineering</td></tr>
                        <tr><td>4</td><td>MT125ME00107</td><td>Automobile Engineering</td></tr>
                        <tr><td>5</td><td>MT125ME00135</td><td>Automobile Engineering</td></tr>
                        <tr><td>6</td><td>MT125ME00029</td><td>Automobile Engineering</td></tr>
                        <tr><td>7</td><td>MT125ME00060</td><td>Automobile Engineering</td></tr>
                        <tr><td>8</td><td>MT125ME00067</td><td>Automobile Engineering</td></tr>
                        <tr><td>9</td><td>MT125ME00108</td><td>Automobile Engineering</td></tr>
                        <tr><td>10</td><td>MT125ME00155</td><td>Automobile Engineering</td></tr>
                    </tbody>
                </table>
                <table className="table table-bordered">
                    <tbody>
                        <tr><th>S.No.</th><th>Application ID</th><th>Specilization Name</th></tr>
                        <tr><td>1</td><td>MT125ME00070</td><td>Computer Integrated Manufacturing</td></tr>
                        <tr><td>2</td><td>MT125ME00075</td><td>Computer Integrated Manufacturing</td></tr>
                        <tr><td>3</td><td>MT125ME00103</td><td>Computer Integrated Manufacturing</td></tr>
                        <tr><td>4</td><td>MT125ME00129</td><td>Computer Integrated Manufacturing</td></tr>
                    </tbody>
                </table>
                <table className="table table-bordered">
                    <tbody>
                        <tr><th>S.No.</th><th>Application ID</th><th>Specilization Name</th></tr>
                        <tr><td>1</td><td>MT125ME00051</td><td>Machine Design</td></tr>
                        <tr><td>2</td><td>MT125ME00100</td><td>Machine Design</td></tr>
                        <tr><td>3</td><td>MT125ME00123</td><td>Machine Design</td></tr>
                        <tr><td>4</td><td>MT125ME00147</td><td>Machine Design</td></tr>
                        <tr><td>5</td><td>MT125ME00157</td><td>Machine Design</td></tr>
                        <tr><td>6</td><td>MT125ME00099</td><td>Machine Design</td></tr>
                        <tr><td>7</td><td>MT125ME00105</td><td>Machine Design</td></tr>
                        <tr><td>8</td><td>MT125ME00145</td><td>Machine Design</td></tr>
                        <tr><td>9</td><td>MT125ME00151</td><td>Machine Design</td></tr>
                        <tr><td>10</td><td>MT125ME00159</td><td>Machine Design</td></tr>
                    </tbody>
                </table>
                <table className="table table-bordered">
                    <tbody>
                        <tr><th>S.No.</th><th>Application ID</th><th>Specilization Name</th></tr>
                        <tr><td>1</td><td>MT125ME00002</td><td>Manufacturing Engineering</td></tr>
                        <tr><td>2</td><td>MT125ME00066</td><td>Manufacturing Engineering</td></tr>
                        <tr><td>3</td><td>MT125ME00087</td><td>Manufacturing Engineering</td></tr>
                        <tr><td>4</td><td>MT125ME00042</td><td>Manufacturing Engineering</td></tr>
                        <tr><td>5</td><td>MT125ME00083</td><td>Manufacturing Engineering</td></tr>
                        <tr><td>6</td><td>MT125ME00104</td><td>Manufacturing Engineering</td></tr>
                    </tbody>
                </table>
                <table className="table table-bordered">
                    <tbody>
                        <tr><th>S.No.</th><th>Application ID</th><th>Specilization Name</th></tr>
                        <tr><td>1</td><td>MT125ME00013</td><td>Thermal Engineering</td></tr>
                        <tr><td>2</td><td>MT125ME00043</td><td>Thermal Engineering</td></tr>
                        <tr><td>3</td><td>MT125ME00073</td><td>Thermal Engineering</td></tr>
                        <tr><td>4</td><td>MT125ME00106</td><td>Thermal Engineering</td></tr>
                        <tr><td>5</td><td>MT125ME00034</td><td>Thermal Engineering</td></tr>
                        <tr><td>6</td><td>MT125ME00072</td><td>Thermal Engineering</td></tr>
                        <tr><td>7</td><td>MT125ME00093</td><td>Thermal Engineering</td></tr>
                        <tr><td>8</td><td>MT125ME00126</td><td>Thermal Engineering</td></tr>
                    </tbody>
                </table>

                <h5 style={{ color: "#2b4675" }}><b>Centre for Materials and Manufacturing:</b></h5>
                <table className="table table-bordered">
                    <tbody>
                        <tr><th>S.No.</th><th>Application ID</th><th>Specilization Name</th></tr>
                        <tr><td>1</td><td>MT125ME00014</td><td>Materials and Manufacturing</td></tr>
                        <tr><td>2</td><td>MT125ME00015</td><td>Materials and Manufacturing</td></tr>
                        <tr><td>3</td><td>MT125ME00082</td><td>Materials and Manufacturing</td></tr>
                        <tr><td>4</td><td>MT125ME00160</td><td>Materials and Manufacturing</td></tr>
                        <tr><td>5</td><td>MT125MM00001</td><td>Materials and Manufacturing</td></tr>
                        <tr><td>6</td><td>MT125MM00006</td><td>Materials and Manufacturing</td></tr>
                    </tbody>
                </table>

                <h5 style={{ color: "#2b4675" }}><b>Department of Metallurgical and Materials Engineering:</b></h5>
                <table className="table table-bordered">
                    <tbody>
                        <tr><th>S.No.</th><th>Application ID</th><th>Specilization Name</th></tr>
                        <tr style={{ color: "red" }} ><center>NIL</center></tr>

                    </tbody>
                </table>



                <h5 style={{ color: "#2b4675" }}><b>Department of Electronics and Communications Engineering:</b></h5>
                <table className="table table-bordered">
                    <tbody>
                        <tr><th>S.No.</th><th>Application ID</th><th>Specilization Name</th></tr>
                        <tr><td>1</td><td>MT125EC00088</td><td>VLSI System Design</td></tr>
                        <tr><td>2</td><td>MT125EC00135</td><td>VLSI System Design</td></tr>
                        <tr><td>3</td><td>MT125EC00178</td><td>VLSI System Design</td></tr>
                        <tr><td>4</td><td>MT125EC00303</td><td>VLSI System Design</td></tr>
                        <tr><td>5</td><td>MT125EC00583</td><td>VLSI System Design</td></tr>
                        <tr><td>6</td><td>MT125EC00089</td><td>VLSI System Design</td></tr>
                        <tr><td>7</td><td>MT125EC00153</td><td>VLSI System Design</td></tr>
                        <tr><td>8</td><td>MT125EC00200</td><td>VLSI System Design</td></tr>
                        <tr><td>9</td><td>MT125EC00526</td><td>VLSI System Design</td></tr>
                        <tr><td>10</td><td>MT125EC00650</td><td>VLSI System Design</td></tr>
                    </tbody>
                </table>
                <table className="table table-bordered">
                    <tbody>
                        <tr><th>S.No.</th><th>Application ID</th><th>Specilization Name</th></tr>
                        <tr><td>1</td><td>MT125EC00023</td><td>Embedded & Machine Learning Systems</td></tr>
                        <tr><td>2</td><td>MT125EC00106</td><td>Embedded & Machine Learning Systems</td></tr>
                        <tr><td>3</td><td>MT125EC00175</td><td>Embedded & Machine Learning Systems</td></tr>
                        <tr><td>4</td><td>MT125EC00299</td><td>Embedded & Machine Learning Systems</td></tr>
                        <tr><td>5</td><td>MT125EC00443</td><td>Embedded & Machine Learning Systems</td></tr>
                        <tr><td>6</td><td>MT125EC00097</td><td>Embedded & Machine Learning Systems</td></tr>
                        <tr><td>7</td><td>MT125EC00159</td><td>Embedded & Machine Learning Systems</td></tr>
                        <tr><td>8</td><td>MT125EC00286</td><td>Embedded & Machine Learning Systems</td></tr>
                        <tr><td>9</td><td>MT125EC00378</td><td>Embedded & Machine Learning Systems</td></tr>
                        <tr><td>10</td><td>MT125EC00568</td><td>Embedded & Machine Learning Systems</td></tr>
                    </tbody>
                </table>
                <table className="table table-bordered">
                    <tbody>
                        <tr><th>S.No.</th><th>Application ID</th><th>Specilization Name</th></tr>
                        <tr><td>1</td><td>MT125EC00127</td><td>Advanced Communication System</td></tr>
                        <tr><td>2</td><td>MT125EC00144</td><td>Advanced Communication System</td></tr>
                        <tr><td>3</td><td>MT125EC00170</td><td>Advanced Communication System</td></tr>
                        <tr><td>4</td><td>MT125EC00341</td><td>Advanced Communication System</td></tr>
                        <tr><td>5</td><td>MT125EC00512</td><td>Advanced Communication System</td></tr>
                        <tr><td>6</td><td>MT125EC00139</td><td>Advanced Communication System</td></tr>
                        <tr><td>7</td><td>MT125EC00162</td><td>Advanced Communication System</td></tr>
                        <tr><td>8</td><td>MT125EC00202</td><td>Advanced Communication System</td></tr>
                        <tr><td>9</td><td>MT125EC00478</td><td>Advanced Communication System</td></tr>
                        <tr><td>10</td><td>MT125EC00610</td><td>Advanced Communication System</td></tr>
                    </tbody>
                </table>

                <h5 style={{ color: "#2b4675" }}><b>Department of Chemical Engineering:</b></h5>
                <table className="table table-bordered">
                    <tbody>
                        <tr><th>S.No.</th><th>Application ID</th><th>Specilization Name</th></tr>
                        <tr><td>1</td><td>MT125CH00014</td><td>Chemical Engineering</td></tr>
                        <tr><td>2</td><td>MT125CH00022</td><td>Chemical Engineering</td></tr>
                        <tr><td>3</td><td>MT125CH00026</td><td>Chemical Engineering</td></tr>
                        <tr><td>4</td><td>MT125CH00033</td><td>Chemical Engineering</td></tr>
                        <tr><td>5</td><td>MT125CH00058</td><td>Chemical Engineering</td></tr>
                        <tr><td>6</td><td>MT125CH00018</td><td>Chemical Engineering</td></tr>
                        <tr><td>7</td><td>MT125CH00025</td><td>Chemical Engineering</td></tr>
                        <tr><td>8</td><td>MT125CH00027</td><td>Chemical Engineering</td></tr>
                        <tr><td>9</td><td>MT125CH00048</td><td>Chemical Engineering</td></tr>
                        <tr><td>10</td><td>MT125CH00059</td><td>Chemical Engineering</td></tr>
                    </tbody>
                </table>
                <table className="table table-bordered">
                    <tbody>
                        <tr><th>S.No.</th><th>Application ID</th><th>Specilization Name</th></tr>
                        <tr><td>1</td><td>MT125CH00005</td><td>Sustainable Energy Generation and Storage Technologies</td></tr>
                        <tr><td>2</td><td>MT125CH00024</td><td>Sustainable Energy Generation and Storage Technologies</td></tr>
                        <tr><td>3</td><td>MT125CH00039</td><td>Sustainable Energy Generation and Storage Technologies</td></tr>
                        <tr><td>4</td><td>MT125CH00052</td><td>Sustainable Energy Generation and Storage Technologies</td></tr>
                        <tr><td>5</td><td>MT125CH00023</td><td>Sustainable Energy Generation and Storage Technologies</td></tr>
                        <tr><td>6</td><td>MT125CH00036</td><td>Sustainable Energy Generation and Storage Technologies</td></tr>
                        <tr><td>7</td><td>MT125CH00051</td><td>Sustainable Energy Generation and Storage Technologies</td></tr>
                        <tr><td>8</td><td>MT125CH00061</td><td>Sustainable Energy Generation and Storage Technologies</td></tr>

                    </tbody>
                </table>


                <h5 style={{ color: "#2b4675" }}><b>Department of Computer Science and Engineering:</b></h5>
                <table className="table table-bordered">
                    <tbody>
                        <tr><th>S.No.</th><th>Application ID</th><th>Specilization Name</th></tr>
                        <tr><td>1</td><td>MT125CS00330</td><td>Computer Science and Engineering</td></tr>
                        <tr><td>2</td><td>MT125CS00770</td><td>Computer Science and Engineering</td></tr>
                        <tr><td>3</td><td>MT125CS00780</td><td>Computer Science and Engineering</td></tr>
                        <tr><td>4</td><td>MT125CS00973</td><td>Computer Science and Engineering</td></tr>
                        <tr><td>5</td><td>MT125CS00980</td><td>Computer Science and Engineering</td></tr>
                        <tr><td>6</td><td>MT125CS00753</td><td>Computer Science and Engineering</td></tr>
                        <tr><td>7</td><td>MT125CS00779</td><td>Computer Science and Engineering</td></tr>
                        <tr><td>8</td><td>MT125CS00954</td><td>Computer Science and Engineering</td></tr>
                        <tr><td>9</td><td>MT125CS00976</td><td>Computer Science and Engineering</td></tr>
                        <tr><td>10</td><td>MT125CS01138</td><td>Computer Science and Engineering</td></tr>
                    </tbody>
                </table>
                <table className="table table-bordered">
                    <tbody>
                        <tr><th>S.No.</th><th>Application ID</th><th>Specilization Name</th></tr>
                        <tr><td>1</td><td>MT125CS00150</td><td>Computer Science and Information Security</td></tr>
                        <tr><td>2</td><td>MT125CS00233</td><td>Computer Science and Information Security</td></tr>
                        <tr><td>3</td><td>MT125CS00767</td><td>Computer Science and Information Security</td></tr>
                        <tr><td>4</td><td>MT125CS00819</td><td>Computer Science and Information Security</td></tr>
                        <tr><td>5</td><td>MT125CS01067</td><td>Computer Science and Information Security</td></tr>
                        <tr><td>6</td><td>MT125CS00194</td><td>Computer Science and Information Security</td></tr>
                        <tr><td>7</td><td>MT125CS00595</td><td>Computer Science and Information Security</td></tr>
                        <tr><td>8</td><td>MT125CS00792</td><td>Computer Science and Information Security</td></tr>
                        <tr><td>9</td><td>MT125CS00820</td><td>Computer Science and Information Security</td></tr>
                        <tr><td>10</td><td>MT125CS01116</td><td>Computer Science and Information Security</td></tr>
                    </tbody>
                </table>

                <h5 style={{ color: "#2b4675" }}><b>Department of Biotechnology:</b></h5>
                <table className="table table-bordered">
                    <tbody>
                        <tr><th>S.No.</th><th>Application ID</th><th>Specilization Name</th></tr>
                        <tr><td>1</td><td>MT125BT00007</td><td>Biotechnology</td></tr>
                        <tr><td>2</td><td>MT125BT000038</td><td>Biotechnology</td></tr>
                        <tr><td>3</td><td>MT125BT00044</td><td>Biotechnology</td></tr>
                        <tr><td>4</td><td>MT125BT00083</td><td>Biotechnology</td></tr>
                        <tr><td>5</td><td>MT125BT00118</td><td>Biotechnology</td></tr>
                        <tr><td>6</td><td>MT125BT00008</td><td>Biotechnology</td></tr>
                        <tr><td>7</td><td>MT125BT000039</td><td>Biotechnology</td></tr>
                        <tr><td>8</td><td>MT125BT00052</td><td>Biotechnology</td></tr>
                        <tr><td>9</td><td>MT125BT00116</td><td>Biotechnology</td></tr>
                        <tr><td>10</td><td>MT125BT00156</td><td>Biotechnology</td></tr>
                    </tbody>
                </table><br /><br />


                <br /><br />
                <ol>
                    <li><a href='https://nitw.ac.in/api/static/files/mtech_sf_2025_2025-5-27-17-3-30.pdf' target='_blank' class="btn btn-primary mt-2">1. Instructions and Physical Reporting schedule for the provisionally selected candidates for M. Tech (Self Finance) Admissions - 2025.</a></li>

                </ol>


            </div>
        </div >
    );
};

export default MTECHSFResultpage;